// extracted by mini-css-extract-plugin
export var black = "_43-6";
export var brand = "_43-1";
export var ddefault = "_43-0";
export var error = "_43-3";
export var gray = "_43-2";
export var highContrast = "_43-8";
export var outline = "_43-7";
export var success = "_43-5";
export var warning = "_43-4";